import { createFileRoute, redirect } from '@tanstack/react-router'
import { Rewards } from '@/sections'
import { isAuthenticated } from '@/api/unified-auth'
import { ProtectedRoute } from '@/components/auth/protected-route'

export const Route = createFileRoute('/rewards')({
  component: RewardsPage,
  beforeLoad: async () => {
    // Redirect to login if not authenticated
    const authenticated = await isAuthenticated()
    if (!authenticated) {
      throw redirect({ to: '/login' })
    }
  },
})

function RewardsPage() {
  return (
    <ProtectedRoute>
      <Rewards />
    </ProtectedRoute>
  )
}
